import { createAction } from '@reduxjs/toolkit';
/**
 * 대시보드 데이터 조회 Action
 */
export const LOAD_DASHBOARD_DATA = 'DASHBOARD/LOAD_DASHBOARD_DATA';
export const CHANGE_DASHBOARD_DATA = 'DASHBOARD/CHANGE_DASHBOARD_DATA';

export const loadDashboardData = createAction(LOAD_DASHBOARD_DATA);
export const changeDashboardData = createAction(CHANGE_DASHBOARD_DATA);
